import Service from '../../services'
import { checkAndReturn } from "../../main"
// import Service from "@/services";

const state = {
    GeneralForm: {},
    ProjectForm: {},
    PlanForm: {},
    OOIForm: {},
    AttachmentForm: {},
    SummaryData: {}
}

const getters = {

}

const actions = {
    getMasterFormA ({ commit }, params) {
        return Service.AForm.getMasterFormA(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    storeFormA ({ commit }, data) {
        return Service.AForm.storeFormA(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    updateFormA ({ commit }, data) {
        return Service.AForm.updateFormA(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    approvedFormA ({ commit }, data) {
        return Service.AForm.approvedFormA(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    RewindStatus ({ commit }, data) {
        console.log("AFORM service", data)
        return Service.AForm.RewindStatus(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    getFormAList ({ commit }, data) {
        return Service.AForm.getFormAList(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    deleteFormAList ({ commit }, data) {
        return Service.AForm.deleteFormAList(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    getEditMasterFormA ({ commit }, data) {
        return Service.AForm.getEditMasterFormA(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },
    storeNewProgressFormA ({ commit }, data) {
        return Service.AForm.storeNewProgressFormA(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },
}

const mutations = {
    setGeneralForm (state, val) {
        state.GeneralForm = val
    },
    setProjectForm (state, val) {
        state.ProjectForm = val
    },
    setPlanForm (state, val) {
        state.PlanForm = val
    },
    setOOIForm (state, val) {
        state.OOIForm = val
    },
    setAttachmentForm (state, val) {
        state.AttachmentForm = val
    },
    addSummaryData (state, val) {
        state.SummaryData = {
            ...state.SummaryData,
            ...val
        }
    },
    clearSummaryData (state) {
        state.SummaryData = {}
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
